import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-notification-reception-demande',
  templateUrl: './notification-reception-demande.component.html',
  styleUrls: ['./notification-reception-demande.component.scss'],
})
export class NotificationReceptionDemandeComponent implements OnInit {

  constructor(private modalController: ModalController) { }

  ngOnInit() { }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'dismissed': true
    });
  }
}
